import { Metamodel } from '../base/model';
import { format, getConnectorV1Name } from '../../shared/utils/string.util';
import { ModelConstants } from '../model-constants';
import { isTridentInIframe } from '../../shared/utils/iframe.utils';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { SalesforceLinkedService } from './salesforce.linkedservice';

@Metamodel.model({
    name: ModelConstants.salesforceServiceCloudLinkedService,
    disabled: isTridentInIframe(),
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate,
            getConnectorV1Name(shellStringResources.SalesforceServiceCloud_DisplayText)),
        format(shellStringResources.ModelName_LinkedServicesTemplate,
            getConnectorV1Name(shellStringResources.SalesforceServiceCloud_DisplayText))
    ]
})
export class SalesforceServiceCloudLinkedService extends SalesforceLinkedService { }
